module.exports = __webpack_public_path__ + "static/media/xem.f6f2a6e4.svg";